import config from '@/config';

export function getDocsUrl(projectName: string, version: string): string {
  return encodeURI(`https://${config.CLOUD_FRONT_DOMAIN}/public/${projectName}/${version}/index.html`);
}
